// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1ZejL","appContent":"App_appContent__167ll"};